export const SKILL_STATUS_OPTIONS = [
  {value: 'DRAFT', label: 'Draft'},
  {value: 'PUBLISHED', label: 'Published'},
  {value: 'ARCHIVED', label: 'Archived'},
];

export const SKILL_DOMAIN_OPTIONS = [
  {value: 'SUPPORT', label: 'Support'},
  {value: 'SALES', label: 'Sales'},
  {value: 'SUCCESS', label: 'Success'},
];

export const SKILL_STATUS_TAG_COLOR = {
  DRAFT: 'default',
  PUBLISHED: 'green',
  ARCHIVED: 'volcano',
};

export const SKILL_LANGUAGE_OPTIONS = [
  {value: 'EN', label: 'English'},
  {value: 'FR', label: 'French'},
];

const toLabel = value =>
  value
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

const buildEnumOptions = values =>
  values.map(value => ({value, label: toLabel(value)}));

export const SKILL_NODE_OPTIONS = buildEnumOptions([
  'REGISTRY',
  'DEPOSIT',
  'WITHDRAWAL',
  'FUNDS',
  'BONDS',
  'STOCKS',
  'ORDERS',
  'DIVIDENDS',
  'VENTURE',
  'VENTURE_FUNDS',
  'IPOS',
  'COLLECTIONS',
  'WATCHLIST',
  'PORTFOLIO',
  'RECURRING_INVESTMENT',
  'TRADE',
  'DABA_PRO',
  'NOTIFICATIONS',
  'STATEMENTS_DOCUMENTS',
  // Support-topic nodes (AI Customer Support rollout)
  'PAYMENTS',
  'KYC',
  'SECURITY',
  'REWARDS',
  'PLATFORM',
]);

export const SKILL_TREE_OPTIONS = buildEnumOptions([
  'REGISTRY',
  'GENERAL',
  'DEPOSIT_ISSUE',
  'PENDING_DEPOSIT',
  'FAILED_DEPOSIT',
  'SUCCESSFUL_DEPOSIT',
  'DEPOSIT_FAQ',
  'DEPOSIT_FOLLOWUP',
  'WITHDRAWAL_ISSUE',
  'PENDING_WITHDRAWAL',
  'FAILED_WITHDRAWAL',
  'SUCCESSFUL_WITHDRAWAL',
  'ORDER_ISSUE',
  'PENDING_ORDER',
  'FAILED_ORDER',
  'SUCCESSFUL_ORDER',
  'CANCELLED_ORDER',
  'SWAP_ISSUE',
  'PENDING_SWAP',
  'FAILED_SWAP',
  'SUCCESSFUL_SWAP',
  'PORTFOLIO_ISSUE',
  'PORTFOLIO_PERFORMANCE',
  'PORTFOLIO_HOLDINGS',
  'PORTFOLIO_VALUATION',
  'PORTFOLIO_DIVIDENDS',
  'SAVINGS_ISSUE',
  'SAVINGS_PLAN',
  'SAVINGS_DEPOSIT',
  'SAVINGS_WITHDRAWAL',
  'SAVINGS_INTEREST',
  'KYC_QUERY',
  'KYC_PENDING',
  'KYC_FAILURE',
  'APP_BUG',
  'PRODUCT_HOWTO',
  'COMPLAINT',
  'GENERAL_FAQ',
  'CLOSING_FLOW',
  // Support-scenario trees (AI Customer Support rollout)
  'ORDER_CANCELLATION',
  'CURRENCY_RESTRICTION',
  'MISSING_REWARD',
  'BILLING',
  'RISK_CUSTODY',
]);
